import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { MemberResourceService } from '../../../api-gen/gen-server/services/member-resource.service';
import { AuthService } from './auth.service';
import { BrowserStorageService } from './browser-storage.service';

@Injectable({
  providedIn: 'root',
})
export class CountryBlockService {
  private memberApi = inject(MemberResourceService);
  private router = inject(Router);
  private authService = inject(AuthService);
  private storage = inject(BrowserStorageService);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  checkAndBlockIfRestricted(): void {
    // Geo-blocking is a per-visitor browser concern. During SSR/prerendering
    // the "visitor" is the render server (or the build machine), so checking
    // there would be meaningless and could redirect crawlers to /region-blocked.
    if (!this.isBrowser) {
      return;
    }

    // check localsotrage for allowuk
    const allowUk = this.storage.getItem('allowuk');
    if (allowUk === 'true') {
      return;
    }
    this.memberApi.membersMeCountryGet().subscribe({
      next: (response) => {
        // Check if the country is England, Scotland, Wales, and Northern Ireland.
        if (response.countryCode === 'GB') {
          this.router.navigate(['/region-blocked']);
          this.authService.logout();
        }
      },
    });
  }
}
